module.exports = __webpack_public_path__ + "img/natuerlich_thumbnail.c76685df.jpg";